var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M8.2 29.5h24.2v2.1H8.2z" }),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M6.8 31.5h27v2.1h-27zM10.8 17.9h3.7v9.4h-3.7zM18.4 17.9h3.7v9.4h-3.7zM26.1 17.9h3.7v9.4h-3.7zM20.3 6.2L8 16.2h24.6l-12.3-10zm0 7.4c-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.1 0 2.1.9 2.1 2.1-.1 1.2-1 2.1-2.1 2.1z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Accounts.svg